import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <footer id="sticky-footer" className="py-4">
        <div className="container">
          <p className="card-text align-items-center" style={{background: "#f2fffa", maxWidth: "35%"}}>
            {this.props.footer ? <img alt="colsubsidio" src={this.props.footer}/> : ""}
          </p>
        </div>
      </footer>
    )
  }
}

export default Footer;
